import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Wraps routes that require admin access.
 * - No session       ? redirects to /login (preserving the intended destination)
 * - Session, no admin ? redirects to /app/dashboard
 * - Session + admin  ? renders children
 *
 * While the session and isAdmin flag are still loading we show the same
 * full-page spinner used by ProtectedRoute.
 */
export default function AdminRoute({ children }: { children: ReactNode }) {
  const { session, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-paper-bg">
        <div className="w-8 h-8 rounded-full border-4 border-surface-container-high border-t-primary-container animate-spin" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <>{children}</>;
}
